import * as React from "react";

export function Linkedin(props) {
  return (
    <svg
      width={54}
      height={51}
      viewBox="0 0 54 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M49.679.765H4.624a4.774 4.774 0 00-1.708.237 4.51 4.51 0 00-1.48.822c-.429.36-.777.795-1.023 1.28A3.807 3.807 0 000 4.647v41.55c.034 1.117.532 2.182 1.392 2.973.86.79 2.016 1.25 3.232 1.28h45.055c1.181-.048 2.295-.52 3.103-1.316.808-.795 1.244-1.85 1.217-2.938V4.646a3.553 3.553 0 00-.311-1.517 3.818 3.818 0 00-.94-1.28 4.207 4.207 0 00-1.413-.833 4.478 4.478 0 00-1.656-.25zM16.875 42.19H9.01V20.05h7.864v22.14zm-3.747-25.494a4.291 4.291 0 01-1.605-.256 4.026 4.026 0 01-1.36-.826 3.648 3.648 0 01-.887-1.258 3.402 3.402 0 01-.265-1.48c-.024-.51.068-1.02.27-1.495.202-.476.51-.907.904-1.267.394-.36.865-.64 1.384-.821a4.297 4.297 0 011.627-.237 4.293 4.293 0 011.606.256c.51.186.973.467 1.36.826.387.359.689.787.887 1.258.198.471.288.975.264 1.48.025.51-.067 1.02-.27 1.495-.202.476-.51.907-.904 1.267-.394.36-.865.64-1.384.821a4.298 4.298 0 01-1.627.237zM45.022 42.19h-7.898V30.08c0-2.888-1.114-4.876-3.915-4.876a4.467 4.467 0 00-2.423.729 3.928 3.928 0 00-1.525 1.88 4.117 4.117 0 00-.27 1.77V42.19h-7.763V20.05h7.763v3.105a7.527 7.527 0 012.968-2.799 8.37 8.37 0 014.119-.959c5.096 0 8.944 3.106 8.944 9.72V42.19z"
        fill="#FAFAFA"
      />
    </svg>
  );
}
